{
	"failedToMigrateProjectStyle": "Failed to migrate project style. Please contact support with your project details."
}
